import type { useAuthStore } from '@vanialabs/core-auth';

type AuthSession = ReturnType<typeof useAuthStore.getState>['session'];

/**
 * Single source of truth for resolving the current access token from
 * an auth session.
 *
 * The core-auth session shape has changed at least once already (a
 * previous flat `session.accessToken` stopped matching the real
 * shape), which silently broke every feature that read the token
 * directly. Every consumer must go through this function instead of
 * reading `session.accessToken` (or any other path) itself, so a
 * future session-shape change only needs to be handled in one place.
 */
export function resolveAccessToken(session: AuthSession): string | undefined {
  if (!session) return undefined;

  const anySession = session as Record<string, any>;

  return (
    anySession.accessToken ??
    anySession.token ??
    anySession.tokens?.accessToken ??
    anySession.tokens?.access ??
    undefined
  );
}
